import { Link } from "react-router-dom";
import Navbar from "../components/feature/Navbar";
import Footer from "../components/feature/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-24 pb-16 flex items-center justify-center">
        <div className="text-center px-4">
          <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
            <i className="ri-emotion-sad-line text-3xl"></i>
          </div>
          <h1 className="mt-6 text-3xl font-heading font-bold text-foreground-900">404</h1>
          <p className="mt-2 text-sm text-foreground-500">您访问的页面不存在</p>
          <Link
            to="/"
            className="mt-6 inline-block px-6 py-2 bg-accent-500 hover:bg-accent-600 text-background-50 rounded-full text-sm font-label font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}